<template>
    <c-layout>
        <c-header :fixed="true">
            <p-top></p-top>
        </c-header>
        <router-view/>
        <c-footer v-if="isFooter">
            <p-footer></p-footer>
        </c-footer>
    </c-layout>
</template>
<script>
import pTop from './pageTop.vue'
import pFooter from './pageFooter.vue'
export default {
  data(){
    return {
      isFooter:true,//是否显示Footer
    }
  },
  components:{
    pTop,
    pFooter
  },
  name:'webLayout',
  created(){
    let path = this.$route.path || ''
    //关键词预注册页面，不显示footer
    this.isFooter = path.indexOf('direct-words-register') < 0 
  }
}
</script>
<style lang="scss" scoped>
</style>